import React, { useEffect, useState } from 'react';
import { locales } from '../../../translations/locales';
import { _setText } from '../../../controllers/dom';
import Map from '../maps/Map';
import NewAlert from './NewAlert';
import ButtonReturnMod from '../configuration/ButtonReturnMod';
import Alert from './Alert';
import { getMarker } from '../../../controllers/markers';
import { booleanPointInPolygon, distance, point, polygon } from '@turf/turf';

const Sga = (props) => {
    const { data, ModuleRP, locale, theme } = props;

    const [newAlert, setNewAlert] = useState(false);
    const [missions, setMissions] = useState([]);
    const [clickData, setClickData] = useState({ lngLat: { lng: 0, lat: 0 } });
    const [automaticLocation, setAutomaticLocation] = useState(false);
    const [cityFocused, setCityFocused] = useState(false);
    const [departmentFocused, setDepartmentFocused] = useState(false);
    const [marker, setMarker] = useState(null);
    const [selectedGtaCity, setSelectedGtaCity] = useState([]);
    const [selectedGtaStreet, setSelectedGtaStreet] = useState([]);

    useEffect(() => {
        _setText('screenName', `<h4 class="m-1">${locales[locale].sga.sga}</h4>`);
        const sortedMissions = [...data.missions].sort((a, b) => b.timestamp - a.timestamp);
        setMissions(sortedMissions);
    }, [data, locale]);

    useEffect(() => {
        if (clickData || data.options.sig.type === 'gtaMap') {
            if (data.options.sig.type === 'worldMap') {
                fetch(`https://api.alertes-speciales.fr/reverse/?lon=${clickData.lngLat.lng}&lat=${clickData.lngLat.lat}&access_token=39bb82568645b321ee454f41e1d413f66c10a54090b1c0d2eb844ad8332ab3ca`) // eslint-disable-line
                    .then((response) => response.json())
                    .then((data) => {
                        data.features[0].properties.lngLat = clickData.lngLat;
                        setAutomaticLocation(data.features[0].properties);
                        setCityFocused(data.features[0].properties.city);
                        setDepartmentFocused(data.features[0].properties.postcode.slice(0, 2));
                    })
                    .catch((error) => console.error('Erreur lors de la récupération des données du clic:', error));
            } else {
                const cityList = [];
                fetch('https://api.alertes-speciales.fr/gtageojson/area?access_token=39bb82568645b321ee454f41e1d413f66c10a54090b1c0d2eb844ad8332ab3ca')
                    .then((response) => response.json())
                    .then((data) => {
                        const zones = [];
                        data.features.forEach((feature) => {
                            cityList.push(feature.properties.name);
                            feature.geometry.coordinates[0].push(feature.geometry.coordinates[0][0]);
                            if (booleanPointInPolygon(point([clickData.lngLat.lng, clickData.lngLat.lat]), polygon(feature.geometry.coordinates))) {
                                zones.push(feature);
                            }
                        });
                        fetch('https://api.alertes-speciales.fr/gtageojson/street?access_token=39bb82568645b321ee454f41e1d413f66c10a54090b1c0d2eb844ad8332ab3ca') // eslint-disable-line
                            .then((response) => response.json())
                            .then((data) => {
                                let streetDistance = Infinity;
                                let selectedStreet = null;
                                const streetList = [];
                                data.features.forEach((featureCity) => {
                                    const dist = distance(
                                        point([clickData.lngLat.lng, clickData.lngLat.lat]),
                                        point(featureCity.geometry.coordinates),
                                        { units: 'kilometers' },
                                    );
                                    streetList.push({
                                        name: featureCity.properties.name,
                                        lngLat: featureCity.geometry.coordinates,
                                        distance: dist,
                                    });
                                    if (dist < streetDistance) {
                                        streetDistance = dist;
                                        selectedStreet = featureCity.properties.name;
                                    }
                                });
                                if (clickData.lngLat.lng !== 0 && clickData.lngLat.lat !== 0) {
                                    setAutomaticLocation({
                                        lngLat: clickData.lngLat,
                                        city: zones[0].properties.name,
                                        street: selectedStreet,
                                        housenumber: '',
                                    });
                                    setCityFocused(zones[0].properties.name.toUpperCase());
                                }
                                cityList.sort();
                                streetList.sort((a, b) => a.distance - b.distance);
                                setSelectedGtaStreet(streetList);
                                setSelectedGtaCity(cityList);
                            })
                            .catch((error) => console.error(`Erreur lors du chargement des streets :`, error));
                    })
                    .catch((error) => console.error(`Erreur lors du chargement des areas :`, error));
            }
        }
    }, [clickData]);

    useEffect(() => {
        if (missions.length > 0) {
            const initMarker = async () => {
                for (let i = 0; i < missions.length; i++) {
                    const mission = missions[i];
                    const _marker = {
                        lngLat: mission.location.lngLat,
                        title: `${locales[locale].sga[mission.qualification.category]} - ${mission.qualification.qualification}`,
                        content: `${mission.qualification.informations}\n
                    ${mission.location.numero} ${mission.location.address} ${mission.location.city}`,
                        icon: `/images/markers/${mission.qualification.category}.png`,
                        id: mission.id,
                    };
                    setMarker(_marker);
                    await new Promise((resolve) => {
                        const checkMarker = setInterval(() => {
                            if (getMarker(mission.id)) {
                                clearInterval(checkMarker);
                                setMarker(null);
                                resolve();
                            }
                        }, 100);
                    });
                }
            };
            initMarker();
        }
    }, [missions]);

    return (
        <div className={`container-fluid bg-${theme === 'DARK' ? 'dark' : 'light'}`}>
            <div className='row'>
                <div className={`col-2 btn-${theme === 'DARK' ? 'dark' : 'light'} btn-sm`}>
                    <ButtonReturnMod loadGame={ModuleRP.loadGame} locale={locale} theme={theme} />
                </div>
            </div>
            <div className='row'>
                {
                    !newAlert ? (
                        <div className='col-6'>
                            <div className='row'>
                                <div className='col-12'>
                                    <button className='btn btn-primary btn-sm m-2 pl-4 pr-4' onClick={() => setNewAlert(true)}>
                                        {locales[locale].sga.createAlert}
                                    </button>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-12'>
                                    {
                                        missions.length > 0 ? (
                                            missions.map((mission, index) => (
                                                <Alert key={index} alert={mission} theme={theme} locale={locale} setNewAlert={setNewAlert} />
                                            ))
                                        ) : (
                                            <div className={`alert alert-${theme === 'DARK' ? 'dark' : 'light'}`}>
                                                <h6 className='alert-heading'>{locales[locale].sga.noAlert}</h6>
                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                    ) : (
                        <NewAlert
                            setNewAlert={setNewAlert}
                            locale={locale}
                            theme={theme}
                            shareAlert={ModuleRP.shareAlert}
                            incidentsCategories={data.incidentsCategories}
                            incidents={data.incidents}
                            places={data.places}
                            alert={newAlert}
                            automaticLocation={automaticLocation}
                            departments={data.options.sig.type === 'worldMap' ? data.options.sigData.departments : []}
                            setCityFocused={setCityFocused}
                            setDepartmentFocused={setDepartmentFocused}
                            departmentFocused={departmentFocused}
                            setMarker={setMarker}
                            selectedGtaCity={selectedGtaCity}
                            selectedGtaStreet={selectedGtaStreet}
                        />
                    )
                }
                <div className={`col-${newAlert ? '4' : '6'}`}>
                    {
                        data.options.sig.active ? (
                            <Map
                                map={data.options.sig.active ? data.options.sig.type : null}
                                data={data.options.sigData}
                                setClickData={setClickData}
                                cityFocused={cityFocused}
                                marker={marker}
                                setMarker={setMarker}
                                gtaMapType={data.options.sigData.gtamap}
                            />
                        ) : (
                            <div className='m-5'>
                                <button className='btn btn-danger' disabled={true}>
                                    {locales[locale].sig.sig}
                                </button>
                            </div>
                        )
                    }
                </div>
            </div>
        </div>
    );
};

export default Sga;
